import { EXTENSION_RETURN_PATH_KEY } from '@/api';

/** Persist the current hash route before an extension auth redirect tears down React state. */
export function saveExtensionReturnPath(): void {
  if (typeof window === 'undefined' || window.location.protocol !== 'chrome-extension:') {
    return;
  }
  const path = window.location.hash.replace(/^#/, '') || '/';
  if (path.startsWith('/login')) return;
  try {
    sessionStorage.setItem(EXTENSION_RETURN_PATH_KEY, path);
  } catch {
    // ignore
  }
}

export function peekExtensionReturnPath(): string | null {
  try {
    return sessionStorage.getItem(EXTENSION_RETURN_PATH_KEY);
  } catch {
    return null;
  }
}

export function clearExtensionReturnPath(): void {
  try {
    sessionStorage.removeItem(EXTENSION_RETURN_PATH_KEY);
  } catch {
    // ignore
  }
}

/** Prefer React Router `location.state.from`, then extension sessionStorage fallback. */
export function resolvePostLoginPath(locationState: unknown, fallback = '/'): string {
  const from = (locationState as { from?: { pathname?: string; search?: string } } | null)?.from;
  if (from?.pathname) {
    return `${from.pathname}${from.search || ''}`;
  }
  return peekExtensionReturnPath() ?? fallback;
}
